/* @flow */
import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import config from '@/services/Api/apiConfig';
import { useShallowEqualSelector } from '@/utils/redux';
import { Redirect } from 'react-router-dom';

let fileUrl = '';
const QuickbaseView = (props) => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let filePath = params.get('filepath');
  let fileName = params.get('filename');
  let leadName = params.get('leadname');

  const [redirect, setRedirect] = useState(false);

  const { token } = useShallowEqualSelector(({ auth }) => ({
    token: auth.profile.token,
  }));

  const getFileExtension = (fileName) => {
    const fileExtension =
      fileName.indexOf('?') !== -1
        ? fileName.slice(fileName.lastIndexOf('.') + 1, fileName.indexOf('?'))
        : fileName.slice(fileName.lastIndexOf('.') + 1, fileName.length);
    return fileExtension;
  };

  useEffect(() => {
    if (token) {
      callApi();
    }
  }, [token]);

  const callApi = async () => {
    try {
      const { data } = await axios({
        method: 'get',
        url: `${config.BASE_URI}/api/get_media_file/${filePath}`,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Token ${token}`,
        },
      });
      if (data) {
        fileUrl = data;
        setRedirect(true);
      }
    } catch (error) {
      alert('Something went wrong', error);
    }
  };

  if (redirect == true) {
    return (
      <Redirect
        to={{
          pathname: '/document-preview',
          state: {
            leadName: leadName,
            fileName: fileName,
            fileUrl: fileUrl,
            format: getFileExtension(fileUrl),
            isFromQuickbase: true,
          },
        }}
      />
    );
  }
};

QuickbaseView.propTypes = {};

const QuickbaseViewMemo = memo<Props>(QuickbaseView);

export default QuickbaseViewMemo;
